import { BasketItemGenqlSelection } from "@/gql/gen";

export const BasketItemFields: BasketItemGenqlSelection = {
    ID: true,
    UUID: true,
    PARENT_ID: true,
    PRODUCT_ID: true,
    QUANTITY: true,
    NAME: true,
    ORDER_ID: true,
    PROPERTIES: {
        __fragment: 'BasketItemProps'
    },
    PRICE: true,
    PRICE_BASE: true,
    FINAL_PRICE: true,
    FINAL_PRICE_BASE: true
}
